// @vue/component
import _groupBy from 'lodash.groupby';
import DashboardListItem from './DashboardListItem';
import { hDeepCopy } from '@/utils/helpers';
import ProgressBar from '../../ProgressBar';

export default {
  name: 'DashboardListForAgents',

  components: {
    DashboardListItem,
    ProgressBar
  },

  props: {
    agentList: {
      type: Array,
      default: () => [],
    },
    projects: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      onlyLogged: '',
    };
  },

  computed: {
    isTakingNewData() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'user/agent/getAgentsList'
      ]);
    },
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'connections/types/getTypeList', 'dashboard/steps/getStepList'
      ]);
    },
    agentTalkingList() {
      return hDeepCopy(this.agentList).filter(agent => agent.is_talking === true);
    },
    agentNotTalkingList() {
      if (this.onlyLogged === false) {
        return hDeepCopy(this.agentList).filter(agent => agent.is_talking === false);
      }
      return hDeepCopy(this.agentList).filter(agent => agent.is_talking === false && agent.is_logged === true);
    },
    agentStatusList() {
      return _groupBy(this.$store.getters['client/project/agents/status/list'].records, 'status_name');
    },
  },
  async created() {
    await this.$store.dispatch('client/project/agents/status/getStatusList');
    this.onlyLogged = localStorage.getItem('showOnlyLoggedAgents') === 'true';
  },
  methods: {
    showOnlyLogged() {
      this.onlyLogged = !this.onlyLogged;
      localStorage.setItem('showOnlyLoggedAgents', this.onlyLogged);
    },
    fetchAgents() {
      this.$store.dispatch('user/agent/getAgentsList',  this.projects)
    },
  }
}
